import React, {Component} from "react";
import linkedin_logo from '../../images/linkedin_gray.png';
import linkedin_logo_off from '../../images/linkedin_gray.png';
import linkedin_logo_colorfully from '../../images/linkedin.png';

export class LinkedinLogo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isHovered: false
        };
    }

    getRenderVeryColoredVersion() {
        if(this.props.renderVeryColoredVersion)
            return this.props.renderVeryColoredVersion;
        return false;
    }

    getIsColoredOnHover() {
        if(this.props.isColoredOnHover)
            return this.props.isColoredOnHover;
        return false;
    }

    handleMouseEnter = () => {
        this.setState({ isHovered: true });
    }

    handleMouseLeave = () => {
        this.setState({ isHovered: false });
    }

    getHspace() {
        if(this.props.hspace !== undefined)
            return this.props.hspace;
        return 10;
    }

    getVspace() {
        if(this.props.vspace !== undefined)
            return this.props.vspace;
        return 10;
    }

    getWidth() {
        return this.props.width || 20;
    }

    getHeight() {
        return this.props.height || 20;
    }



    getImage() {
        if(this.getRenderVeryColoredVersion())
            return linkedin_logo_colorfully;
        return !this.getIsColoredOnHover() || this.state.isHovered ? linkedin_logo : linkedin_logo_off;
    }

    render() {
        return <img alt="LinkedIn Ads" style={this.props.styles} src={this.getImage()} height={this.getHeight()}
                    width={this.getWidth()} hspace={this.getHspace()} vspace={this.getVspace()}
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
        />
    }
}
